module.exports = __webpack_public_path__ + "sunsemweb/img/pmap.1589bd43.jpg";